import { connect } from 'react-redux';

import { StoreState } from '../../reducers';
import ShareWithUserPopup from '../../components/ShareWithUserPopup';

const mapStateToProps = (state: StoreState) => {
	const {
		shareWithUserPopup: {
			isDisplayed,
			isLoading,
			users,
			selectedUserId,
		},
	} = state;

	return {
		isDisplayed,
		isLoading,
		users,
		selectedUserId,
	};
};

export default connect(mapStateToProps)(ShareWithUserPopup);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ShareWithUserPopup/index.tsx